import {
  isInAppAndroidBrowser,
  isInAppBrowser,
  isMobile,
} from "./isInAppBrowser";

export function calculatePageType() {
  if (isInAppAndroidBrowser()) {
    return "inapp-android";
  }
  if (isInAppBrowser()) {
    return "inapp-ios";
  }
  if (isMobile()) {
    return "mobile";
  }
  return "desktop";
}
